module.exports = __webpack_public_path__ + "img/1696207924714-WhatsApp Image 2023-10-02 at 08.37.33 1.jpeg.3f97eb53.webp";